import { render, staticRenderFns } from "./ParticipateButton.vue?vue&type=template&id=2682bf04&scoped=true&"
import script from "./ParticipateButton.vue?vue&type=script&lang=ts&"
export * from "./ParticipateButton.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipateButton.vue?vue&type=style&index=0&id=2682bf04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682bf04",
  null
  
)

export default component.exports